export default {
  id: {
    value: null,
    options: [],
    clearOption: true,
    required: false,
    state: null
  },
  sinisterCode: {
    value: '',
    maxlength: '20',
    required: true,
    state: null
  },
  sinisterVersion: {
    value: '',
    maxlength: '2',
    required: true,
    state: null
  },
  insuranceID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  stageID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  regulationTypeID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  sinisterDate: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  receiptDate: {
    value: '',
    maxlength: '30',
    required: true,
    state: null
  },
  responsibleID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  businessTypeID: {
    value: null,
    options: [],
    clearOption: true,
    required: true,
    state: null
  },
  budgetSystemID: {
    value: null,
    options: [],
    clearOption: false,
    required: true,
    state: null
  },
  mechanicalWorkshopID: {
    value: '',
    maxlength: '60',
    required: true,
    state: null
  },
  autoTypeID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  autoboard: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  brandID: {
    value: null,
    options: [],
    clearOption: true,
    required: false,
    state: null
  },
  autoModelID: {
    value: null,
    options: [],
    clearOption: true,
    required: false,
    state: null
  },
  budgetNumber: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  },
  year: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  },
  color: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  },
  plate: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  },
  chassis: {
    value: '',
    maxlength: '50',
    required: false,
    state: null
  },
  seem: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '2',
    noResize: true
  },
  damageClaimed: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '2',
    noResize: true
  },
  description: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '4',
    noResize: true
  },
  insuredID: {
    value: '',
    maxlength: '60',
    required: false,
    state: null
  },
  conductorID: {
    value: '',
    maxlength: '60',
    required: false,
    state: null
  },
  thirdID: {
    value: '',
    maxlength: '60',
    required: false,
    state: null
  },
  productID: {
    value: null,
    options: [],
    clearOption: true,
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/auto/details/sinisterdetails-form.js